// >=1           保留2位
// 0.1~1         保留2位
// 0.01~0.1      保留3位
// 0.001~0.01    保留5位
// <0.001        才开始压缩0


//              余额格式化函数
export function formatAmount(value: string | number): string {
  const str = String(value);
  const num = Number(str);

  if (!isFinite(num) || num === 0) return "0";

  if (num >= 1) return num.toFixed(2).replace(/\.?0+$/, "");

  if (num >= 0.1) return num.toFixed(2).replace(/\.?0+$/, "");

  if (num >= 0.01) return num.toFixed(3).replace(/\.?0+$/, "");

  if (num >= 0.001) return num.toFixed(5).replace(/\.?0+$/, "");

  // 小于0.001开始压缩
  const decimal = str.split(".")[1] ?? "";

  const zeroCount = decimal.match(/^0*/)?.[0].length ?? 0;
  

  const significant = decimal.slice(zeroCount).slice(0, 3);

  return `0.0{${zeroCount - 1}}${significant}`;
}